import { createBrowserRouter, Navigate } from 'react-router-dom';
import { lazy } from 'react';
import routes from './routes';
import checkAuth from './app/auth';
import AppWrapper from './components/AppWrapper';

// Lazy load top-level components
const Layout = lazy(() => import('./containers/Layout'));
const Login = lazy(() => import('./pages/Login'));
const ForgotPassword = lazy(() => import('./pages/ForgotPassword'));
const ActivateAccount = lazy(() => import('./pages/ActivateAccount'));
const ResetPassword = lazy(() => import('./pages/ResetPassword'));
const TermsOfService = lazy(() => import('./pages/TermsOfService'));
const RegistrationForm = lazy(() => import('./pages/RegistrationForm'));
const AthleteSignup = lazy(() => import('./pages/AthleteSignup'));

const token = checkAuth();

export const router = createBrowserRouter([
	{
		element: <AppWrapper />,
		children: [
	{
		path: '/reset-password/:userId/:resetToken',
		Component: ResetPassword,
	},
	{
		path: '/activate-account/:userId/:verificationCode',
		Component: ActivateAccount,
	},
	{
		path: '/login',
		Component: Login,
	},
	{
		path: '/forgot-password',
		Component: ForgotPassword,
	},
	{
		path: '/terms-of-service',
		Component: TermsOfService,
	},
	{
		path: '/registration',
		Component: RegistrationForm,
	},
	{
		path: '/signup',
		Component: AthleteSignup,
	},
	{
		path: '/app',
		Component: Layout,
		children: routes,
	},
		{
			path: '*',
			element: <Navigate to={token ? '/app/dashboard' : '/login'} replace />,
		},
		],
	},
]);
